import { fetchPublicAPI } from "hooks/usePublicAPI";

/** POSTs to a public grant endpoint without the visitor's own bearer
 * token: a signed-in submitter confirming a channel must not present
 * their current session to a route that authorizes by grant alone. */
export function postGrantRequest<T>(
  route: string,
  payload: Record<string, string>,
): Promise<T> {
  return fetchPublicAPI<T>(route, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
